import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, HostBinding, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'cm-snackbar-a11y',
    templateUrl: './cm-snackbar-a11y.component.html',
    styleUrls: ['./cm-snackbar-a11y.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CmSnackBarA11yComponent {
	@HostBinding('class.mat-simple-snackbar') snackBarClass = true;
	@HostBinding('attr.aria-hidden') ariaHidden = true;

	constructor(
		private readonly liveAnnouncer: LiveAnnouncer,
		@Inject(MAT_SNACK_BAR_DATA) public readonly data: { message: string; action?: string },
		private readonly snackBarRef: MatSnackBarRef<CmSnackBarA11yComponent>
	) {
		this.liveAnnouncer.announce(this.data.message);
	}

	close(): void {
		this.snackBarRef.dismiss();
	}
}
